/**
 * @fileoverview Local da OS no Contele (aba "Conclusão" do editor de triagem):
 * quando a triagem é concluída, pela IA ou por uma pessoa, o Chat cria (ou
 * atualiza) na conta do Contele escolhida o Local da OS — nome "nº da OS +
 * cliente", CPF, endereço e telefone. Os itens marcados vão junto: o texto nas
 * Observações do Local; foto, vídeo e documento por um link que vale 60 dias.
 * Usa os dados da OS: só com o início pela OS ligado. As contas são
 * cadastradas pela Sttelar em Integrações.
 */

import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { i18n } from "../../../../translate/i18n";
import ModernSelect from "../../../../components/ModernSelect";
import useStyles from "./styles";
import SectionTitle from "./InfoTip";

const x = (key) => i18n.t(`triage.manager.editor.customerExport.${key}`);

// Itens cuja resposta é um arquivo: vão pelo link das mídias.
const MEDIA_INPUTS = ["image", "document", "document_or_image", "video", "audio"];

const CustomerExportEditor = ({ value, onChange, accounts, items, workOrdersEnabled, removed }) => {
  const classes = useStyles();
  const account = accounts.find((a) => String(a.id) === String(value.integrationId)) || null;
  const set = (patch) => onChange({ ...value, ...patch });
  const withKey = items.filter((it) => it.key);

  // Uma conta só: já vem escolhida ao ligar.
  const toggle = (enabled) =>
    set({ enabled, integrationId: enabled && value.integrationId === "" && accounts.length === 1 ? accounts[0].id : value.integrationId });

  // Na ordem dos itens da triagem (é a ordem das Observações).
  const toggleItem = (key) => {
    const chosen = value.items.includes(key) ? value.items.filter((k) => k !== key) : [...value.items, key];
    set({ items: withKey.map((it) => it.key).filter((k) => chosen.includes(k)) });
  };

  return (
    <div>
      <SectionTitle title={x("title")} info={x("info")} />
      <FormControlLabel
        className={classes.check}
        control={
          <Switch
            color="primary"
            checked={value.enabled}
            // Sem o início pela OS não liga; ligado antes, dá para desligar.
            disabled={!workOrdersEnabled && !value.enabled}
            onChange={(ev) => toggle(ev.target.checked)}
          />
        }
        label={x("enabled")}
      />
      {!workOrdersEnabled && <div className={value.enabled ? classes.warnText : classes.hint}>{x("needsWorkOrders")}</div>}

      {value.enabled && !removed && accounts.length === 0 && <div className={classes.warnText}>{x("noAccounts")}</div>}
      {value.enabled && accounts.length > 0 && (
        <ModernSelect
          className={classes.field}
          size="small"
          fullWidth
          label={x("account")}
          InputLabelProps={{ shrink: true }}
          displayEmpty
          value={account ? account.id : ""}
          onChange={(ev) => set({ integrationId: ev.target.value })}
        >
          <MenuItem value="">
            <em>{x("accountChoose")}</em>
          </MenuItem>
          {accounts.map((a) => (
            <MenuItem key={a.id} value={a.id}>
              {a.active ? a.name : `${a.name} (${x("inactiveTag")})`}
            </MenuItem>
          ))}
        </ModernSelect>
      )}
      {value.enabled && removed && <div className={classes.warnText}>{x(accounts.length ? "removed" : "removedNone")}</div>}
      {value.enabled && account && !account.active && <div className={classes.warnText}>{x("inactive")}</div>}

      {value.enabled && withKey.length > 0 && (
        <div className={classes.exportItems}>
          <SectionTitle title={x("items")} info={x("itemsInfo")} />
          <div className={classes.optionGrid}>
            {withKey.map((it) => (
              <FormControlLabel
                key={it.uid}
                className={classes.check}
                control={
                  <Checkbox size="small" color="primary" checked={value.items.includes(it.key)} onChange={() => toggleItem(it.key)} />
                }
                label={MEDIA_INPUTS.includes(it.inputType) ? `${it.name.trim() || it.key} (${x("byLink")})` : it.name.trim() || it.key}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerExportEditor;
